import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { RouterLink } from '@angular/router';
import { GrooveSurfaceDirective } from '@groove/angular';

/**
 * A jump-nav entry targets one of two things (spec §15.1, 2026-09-14): most
 * stay on the page (`fragment`, the default — routerLink="." + [fragment]).
 * An entry may instead leave the page via `path` (no `fragment`) — it
 * renders with the same text-link role plus a trailing "→" (CSS alt-text
 * idiom, `jump-nav-link-path`) so it reads as "goes somewhere". Exactly one
 * of `fragment`/`path` is set per entry; the type doesn't enforce that
 * (both optional) because a discriminated union would force every existing
 * fragment-only literal array to add an explicit `path: undefined`.
 */
export interface JumpNavLink {
  readonly label: string;
  readonly fragment?: string;
  readonly path?: string;
}

@Component({
  selector: 'app-jump-nav',
  imports: [RouterLink, GrooveSurfaceDirective],
  templateUrl: './jump-nav.component.html',
  styleUrl: './jump-nav.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class JumpNavComponent {
  readonly links = input.required<readonly JumpNavLink[]>();
  readonly label = input<string>('Jump to:');
}
